<h1>{{ 'Turbo.FleetManager.EditObjectDialog.Headline' | translate : 'Edit rental object' }}</h1>

<div style="width: 400px;">
    <div class="turboContainer">
        <mat-form-field style="width: 100%;">
            <input matInput placeholder="{{'Turbo.FleetManager.EditObjectDialog.txtTitle' | translate : 'Registration number'}}" [(ngModel)]="title" />
        </mat-form-field>
        <mat-form-field style="width: 100%;">
            <input matInput placeholder="{{'Turbo.FleetManager.EditObjectDialog.txtAlias' | translate : 'Trailer number'}}" [(ngModel)]="alias" />
        </mat-form-field>
        <mat-form-field style="width: 100%;">
            <mat-select placeholder="{{'Turbo.FleetManager.EditObjectDialog.drpType' | translate : 'Type'}}" [(value)]="type">
                <mat-option value="421">Small</mat-option>
                <mat-option value="422">Medium</mat-option>
                <mat-option value="340">Large</mat-option>
                <mat-option value="423">XL</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div style="text-align: center">
        <button class="btn btn-default" style="margin: 2px;" color="primary" (click)="save()">{{'Turbo.FleetManager.EditObjectDialog.cmdSave' | translate : 'Save'}}</button>
    </div>
</div>